export function loadVideoPlayer(player, width, height, prepareContainer) {
	player.style.width = `${width}px`;
	player.style.height = `${height}px`;
	player.classList.add('platformPlayer');

	if (prepareContainer instanceof Function){
		prepareContainer();
	}

	let loader = window.criticalVideoLoader;
	let configData = loader.getVideoElementsData().map((data) => { return data; });

	loader.loadScript(loader.loadVideos.bind(loader), configData, true);

}

export function preparePlayerConfig(playerConfig){
	let result = Object.assign({}, playerConfig);
	result = replaceWithDashes(result, ['iu', 'categoryName', 'siteSection', 'pageName']);

	return JSON.stringify(result);
}

function replaceWithDashes(playerConfig, propNames) {
	propNames.forEach((propName) => {
		if (typeof playerConfig[propName] === 'string' || playerConfig[propName] instanceof String) {
			playerConfig[propName] = playerConfig[propName].replace(/%20/g,'-');
		}
	});

	return playerConfig;
}



// WEBPACK FOOTER //
// ./react-app-src/shared/services/VideoPlayerService.js